module.exports = __webpack_public_path__ + "static/media/pop-music-fans.30cf5ff4.jpg";